export enum CryptocurrencySubSteps {
    MAIN = 'main',
    CRYPTOCURRENCY = 'cryptocurrency',
}